<div
  class="container-fluid d-flex flex-column justify-content-center align-items-center"
>
  <mat-icon svgIcon="app_not_found"></mat-icon>
  <button
    mat-button
    (click)="backToMain()"
    class="button-primary mat-button-base game-btn"
  >
    Back To Home
  </button>
</div>
